import ButtonImage from '../../components/ButtonImage';
import {Link} from '@material-ui/core';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import ButtonImageBorder from '../../components/ButtonImageBorder';
import {application} from 'configs/app';

export class AppBanner {
  constructor() {
    AppBanner.instance = this;
  }
  static get() {
    if (!AppBanner.instance) {
      AppBanner.instance = new AppBanner();
      AppBanner.instance.limitWithdraw = 1000000;
      AppBanner.instance.maxWithdraw = undefined;
      AppBanner.instance.voicCall = true;
      AppBanner.instance.videoCall = true;
      AppBanner.instance.whiteList = [];
    }
    return AppBanner.instance;
  }

  static async fetchBannerInfo() {
    try {
      let response = await fetch(
        application.endpoint + '/core/v1/setting/app-general-config/formated',
        {
          cache: 'no-store',
        },
      );

      let resJson = await response.json();
      let jsonArray = resJson.config;
      const ratePattern = /^\d+$/;
      jsonArray &&
        jsonArray.forEach(function (item, index) {
          /* eslint-disable default-case */
          switch (item.id) {
            case 'home':
              AppBanner.get().homeBannerImage = AppBanner.getBannerView(
                item.url,
                application.endpoint + '/files/' + item.link !== null
                  ? application.endpoint + '/files/' + item.link
                  : null,
              );
              break;
            case 'homeNew':
              AppBanner.get().homeNewBannerImage =
                AppBanner.getBannerViewBorder(
                  item.url,
                  application.endpoint + '/files/' + item.link !== null
                    ? application.endpoint + '/files/' + item.link
                    : null,
                );
              break;
            case 'social':
              AppBanner.get().socialBannerImage = AppBanner.getBannerView(
                item.url,
                application.endpoint + '/files/' + item.link !== null
                  ? application.endpoint + '/files/' + item.link
                  : null,
              );
              break;
            case 'damopet':
              AppBanner.get().damopetBannerImage = AppBanner.getBannerView(
                item.url,
                application.endpoint + '/files/' + item.link !== null
                  ? application.endpoint + '/files/' + item.link
                  : null,
              );
              break;
            case 'advisers':
              AppBanner.get().advisersBannerImage = AppBanner.getBannerView(
                item.url,
                application.endpoint + '/files/' + item.link !== null
                  ? application.endpoint + '/files/' + item.link
                  : null,
              );
              break;
            case 'limitWithdraw':
              if (ratePattern.test(item.value)) {
                AppBanner.get().limitWithdraw = item.value;
              }
              break;
            case 'maxWithdraw':
              if (ratePattern.test(item.value)) {
                AppBanner.get().maxWithdraw = item.value;
              }
              break;
            case 'rtcSetting':
              AppBanner.get().voicCall = item.voiceCall === true;
              AppBanner.get().videoCall = item.videoCall === true;
              AppBanner.get().whiteList = item.whiteList;
              break;
            case 'questions':
              AppBanner.get().questions = item.value;
              break;
          }
          /* eslint-enable default-case */
        });
    } catch (error) {
      console.error(error);
    }
  }

  static getBannerById(id) {
    /* eslint-disable default-case */

    switch (id) {
      case 'homeNew':
        return AppBanner.get().homeNewBannerImage;
      case 'home':
        return AppBanner.get().homeBannerImage;
      case 'social':
        return AppBanner.get().socialBannerImage;
      case 'damopet':
        return AppBanner.get().damopetBannerImage;
      case 'advisers':
        return AppBanner.get().advisersBannerImage;
    }
    /* eslint-enable default-case */

    return null;
  }

  static getBannerView(url, link) {
    return (
      <Grid item>
        <ButtonImage
          src={link}
          component={Link}
          href={url}
          target={'_self'}
          rel="noopener"
        />
      </Grid>
    );
  }

  static getBannerViewBorder(url, link) {
    return (
      <Grid item>
        <ButtonImageBorder
          src={link}
          component={Link}
          href={url}
          target={'_self'}
          rel="noopener"
        />
      </Grid>
    );
  }
}
